<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppDatePicker from '@/components/app/DatePicker.vue';
  export default {
    components: {
      AppDatePicker,
    },
    props: {
      fromDate: {
        type: String,
        default: '',
        required: true,
      },
      toDate: {
        type: String,
        default: '',
        required: true,
      },
      input: {
        type: Object,
        default: () => ({
          fromDate: '',
          toDate: '',
        }),
        required: true,
      },
      isFilterModalOpen: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ['close-filter-modal', 'search'],
    data() {
      return {
        filterFields: {
          fromDate: '',
          toDate: '',
        },
      };
    },
    methods: {
      _search: function () {
        this.$emit('search', {
          fromDate: this.filterFields.fromDate || null,
          toDate: this.filterFields.toDate || null,
        });
      },
    },
  };
</script>
<template>
  <v-dialog persistent :value="isFilterModalOpen" width="400">
    <v-card>
      <v-row no-gutters>
        <v-col cols="12" class="modal-header py-2">
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-icon color="darkColor">mdi-magnify</v-icon>
            <span class="modal-title-text mr-2">جستجو</span>
            <v-spacer></v-spacer>
          </v-row>
        </v-col>
      </v-row>
      <v-card-text class="mt-12">
        <v-row>
          <v-col cols="12">
            <app-date-picker
              inputID="fromDate"
              label="از تاریخ"
              :input-value="fromDate"
              v-model="filterFields.fromDate"
            />
          </v-col>
          <v-col cols="12">
            <app-date-picker
              inputID="toDate"
              label="تا تاریخ"
              :input-value="toDate"
              v-model="filterFields.toDate"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <v-btn color="darkColor" @click="_search" dark rounded class="normal-letter-spacing px-12">
          جستجو
        </v-btn>
        <v-btn
          rounded
          color="darkColor"
          outlined
          @click="$emit('close-filter-modal')"
          class="normal-letter-spacing px-10"
        >
          انصراف
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style lang="css"></style>
